import React, { FC, useContext, useEffect } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { handleLabelNameChanges } from 'src/cms/helpers/automation'
import { checkIsActive } from '../../../helpers'
import { ActiveMenuContex } from '../../MasterLayout'
import {
  getMenuIcon,
  ASIDE_ACCENT,
  ASIDE_ACTIVE_BG,
  ASIDE_ICON_MUTED,
  ASIDE_TEXT,
} from './asideStyles'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  isSubItem?: boolean
}

const isExternalUrl = (url: string): boolean => /^https?:\/\//i.test(url)

const AsideMenuItem: FC<Props> = ({
  children,
  to,
  title,
  isSubItem = false,
}) => {
  const { pathname } = useLocation()
  const isActive = !isExternalUrl(to) && checkIsActive(pathname, to)
  const activeMenu: any = useContext(ActiveMenuContex)
  const Icon = getMenuIcon(title)

  useEffect(() => {
    if (isActive) {
      activeMenu?.setCurrentActiveMenu(title)
      sessionStorage.setItem('activeMenu', title)
    }
  }, [isActive, title, activeMenu])

  const linkStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: isSubItem ? '10px 16px 10px 44px' : '12px 16px',
    borderLeft: isActive ? `4px solid ${ASIDE_ACCENT}` : '4px solid transparent',
    background: isActive ? ASIDE_ACTIVE_BG : 'transparent',
    color: isActive ? ASIDE_ACCENT : ASIDE_TEXT,
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: isActive ? 600 : 400,
    cursor: 'pointer',
    transition: 'background 0.15s, color 0.15s, border-left-color 0.15s',
  }

  const iconStyle: React.CSSProperties = {
    color: isActive ? ASIDE_ACCENT : ASIDE_ICON_MUTED,
    flexShrink: 0,
    display: 'flex',
  }

  const commonContent = (
    <>
      <span style={iconStyle}>
        <Icon size={isSubItem ? 16 : 20} />
      </span>
      <span>{title}</span>
    </>
  )

  return (
    <div>
      {isExternalUrl(to) ? (
        <a
          href={to}
          target='_blank'
          rel='noopener noreferrer'
          style={linkStyle}
          data-cy={`${handleLabelNameChanges(title)}-menu-item`}
          onClick={() => activeMenu?.setOpen(!activeMenu?.open)}
        >
          {commonContent}
        </a>
      ) : (
        <Link
          to={to}
          style={linkStyle}
          data-cy={`${handleLabelNameChanges(title)}-menu-item`}
          onClick={() => activeMenu?.setOpen(!activeMenu?.open)}
        >
          {commonContent}
        </Link>
      )}
      {children}
    </div>
  )
}

export { AsideMenuItem }
